import { Message } from 'element-ui';
export default {
    //vue插件install方法
    install(Vue) {
        //注册实例快捷方法
        Vue.prototype.$_msg = {
            //消息成功提示
            success(message, { ...options }) {
                return Message.success({
                    message,
                    background: true,
                    ...options
                });
            },

            //消息失败提示
            error(message, { ...options }) {
                return Message.error({
                    message,
                    background: true,
                    ...options
                });
            },


            //加载中消息提示
            loading(message = '加载中...', { ...options }) {
                return Message.loading({
                    message,
                    background: true,
                    ...options
                });
            }

        };
    }
}